import React from 'react';
function Page({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.75 4H7.5c-.398 0-.78.169-1.06.469-.282.3-.44.707-.44 1.131v12.8c0 .424.158.831.44 1.131.28.3.662.469 1.06.469h9c.398 0 .78-.169 1.06-.469.282-.3.44-.707.44-1.131V9.6L12.75 4z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M13 4v5h5" />
    </svg>
  );
}

export default Page;
